import {
  Component,
    EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith, switchMap, tap } from 'rxjs/operators';

import { Patient } from 'src/app/core/models/patient/patient';
import { PatientAddress } from 'src/app/core/models/patient/patientAddress';
import { PatientEmployerInfo } from '../../../../core/models/patient/patientEmployerInfo';
import { EmployerService } from '../../../../core/services/v2/employer.service';
import { PatientService } from '../../../../core/services/v2/patient.service';
import { WindowLoaderService } from '../../../../shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-profile-employement-info',
  templateUrl: './profile-employement-info.component.html',
  styleUrls: ['./profile-employement-info.component.scss']
})
export class ProfileEmployementInfoComponent implements OnInit {
  constructor(
    public dialog: MatDialog,
    private loaderService: WindowLoaderService,
    private employerService: EmployerService,
    private patientService: PatientService,
  ) { }
  @Input() patientProfile: Patient;
  @Input() employmentAddresses: PatientAddress[];
  @Output() toggleEditEvent = new EventEmitter();
  patientWorkAddressDetails: PatientAddress = new PatientAddress();
  IsPatientWorkAddress: boolean = false;
  @ViewChild('contactHrDialog', { static: false }) contactHrDialog: TemplateRef<any>;
  private contactHrDialogRef: MatDialogRef<TemplateRef<any>>;
  searchEmployer: FormControl = new FormControl('');
  selectedLocation: FormControl = new FormControl('');
  employersFilteredOptions: Observable<any[]>;
  showAddFromDb: boolean = true;
  showLocations: boolean = false;
  patientEmployer: PatientEmployerInfo;
  selectedEmployer: any;

  ngOnInit() {
    if (this.employmentAddresses != undefined) {
      let patientWorkAddressList = this.employmentAddresses.filter(q => q.type == "WORK");
      if (patientWorkAddressList.length > 0) {
        this.IsPatientWorkAddress = true;
        this.patientWorkAddressDetails = patientWorkAddressList[0];
      }
    }

    if (this.patientProfile && this.patientProfile.patientEmployerInfo && this.patientProfile.patientEmployerInfo.length > 0) {
      this.showAddFromDb = false;
    }
    else {
      this.employersFilteredOptions = this.searchEmployer.valueChanges.pipe(
        startWith(''),
        debounceTime(400),
        distinctUntilChanged(),
        switchMap((val) => {
          if (!val) {
            return new Observable<any[]>();
          }
          return this.filterEmployeList(val || '');
        })
      );
    }
  }

  filterEmployeList(searchString: string) {
    return this.loaderService.blockWithLoader(this.employerService.getEmployerDataByName(1, 50, searchString, 1)).pipe(
      tap(),
      map((response) => {
        return response.pageItems;
      })
    );
  }

  selectEmployer(employer: any) {
    this.searchEmployer.setValue(employer.employerName);
    let locations = employer.employerLocations;
    if (locations && locations.length > 0) {
      for (let i = 0; i < locations.length; i++) {
        if (locations[i].employerBasicDetails) {
          locations[i].employerBasicDetails = JSON.parse(locations[i].employerBasicDetails);
        }
        if (locations[i].employerHrContactDetails) {
          locations[i].employerHrContactDetails = JSON.parse(locations[i].employerHrContactDetails);
        }
      }
      employer.employerLocations = locations;
      this.selectedEmployer = employer;
    }
    this.showLocations = true;
  }

  updateEmployerInfo() {
    const locationId = this.selectedLocation.value;
    if (locationId > 0) {
      const data = this.selectedEmployer.employerLocations.filter(x => x.id === locationId)[0];
      let hrContactEmail = '';
      let hrContactName = '';
      let hrContactPhoneNumber = '';
      if (data.employerHrContactDetails && data.employerHrContactDetails.length > 0) {
        hrContactEmail = data.employerHrContactDetails[0].emailAddress;
        hrContactName = data.employerHrContactDetails[0].firstName + ' ' + data.employerHrContactDetails[0].lastName;
        hrContactPhoneNumber = data.employerHrContactDetails[0].primaryPhoneNumber;
      }

      this.patientEmployer = {
        id: 0,
        patientId: this.patientProfile.id,
        employerName: this.selectedEmployer.employerName,
        jobTitle: '',
        hrContactEmail: hrContactEmail,
        hrContactName: hrContactName,
        hrContactPhoneNumber: hrContactPhoneNumber,
        dependents: null
      }
      this.loaderService.blockWithLoader(this.patientService.updatePatientEmployerInfo(this.patientEmployer)).subscribe(
        (_) => {
          this.patientProfile.patientEmployerInfo[0] = this.patientEmployer;
          this.showAddFromDb = false;
        },
        (error) => { console.error(error); }
      );
    }
  }

  toggleEdit() {
    this.toggleEditEvent.emit();
  }

  messageHr() {
    if (this.patientProfile.patientEmployerInfo.length > 0) {
      if (this.patientProfile.patientEmployerInfo[0].hrContactEmail) {
        this.contactHrDialogRef = this.dialog.open(this.contactHrDialog, {
          panelClass: `hrContact-dialog--popup`,
          width: '528px',
          disableClose: false,
          data: { pid: this.patientProfile.id, email: this.patientProfile.patientEmployerInfo[0].hrContactEmail, name: this.patientProfile.patientEmployerInfo[0].hrContactName, message: '' }
        });
      }
    }
  }
  sendMessage(data: any) {
    console.log(data);
    this.contactHrDialogRef.close();
  }
  cancel() {
    this.contactHrDialogRef.close();
  }
}
